// constants
import { TABS, LAYOUT_MODES } from "../../constants/index";

import { LayoutActionTypes, LayoutState } from "./types";
import { SKeys } from "../../const";

export const INIT_STATE: LayoutState = {
  //activeTab: (localStorage.getItem(SKeys.EmbActiveTab) ?? TABS.CHAT) == TABS.WORKPLACE ? TABS.WORKPLACE : TABS.CHAT,
  activeTab: (():
    | TABS.BOOKMARK
    | TABS.CALLS
    | TABS.CHAT
    | TABS.CHAT_SUP
    | TABS.CONTACTS
    | TABS.SETTINGS
    | TABS.USERS
    | TABS.TEST
    | TABS.WORKPLACE => {
    const mem = localStorage.getItem(SKeys.EmbActiveTab);
    if (mem === TABS.WORKPLACE) return TABS.WORKPLACE;
    if (mem === TABS.CHAT) return TABS.CHAT;
    if (mem === TABS.CHAT_SUP) return TABS.CHAT_SUP;
    return TABS.CHAT;
  })(),


  //layoutMode: "light"(localStorage.getItem("lm") ? (localStorage.getItem("lm") as any) ? LAYOUT_MODES.LIGHT),
  layoutMode: (localStorage.getItem("lm") ?? LAYOUT_MODES.LIGHT) as LAYOUT_MODES,
  chatConnectError: null,
  isGrantNotification: false
};

const Layout = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LayoutActionTypes.CHANGE_TAB:
      // console.log("LayoutActionTypes.CHANGE_TAB = " + action.payload);
      return {
        ...state,
        activeTab: action.payload,
      };

    case LayoutActionTypes.CHANGE_LAYOUT_MODE:
      return {
        ...state,
        layoutMode: action.payload.layoutMode,
      }

    case LayoutActionTypes.SET_GLOBAL_ERROR:
      return {
        ...state,
        chatConnectError: action.payload,
      }
    case LayoutActionTypes.SET_PERM_NOTIFICATION:
      return { ...state, isGrantNotification: action.payload }

    case LayoutActionTypes.SET_IS_IN_FRAME:
      const { isInFrame } = action.payload;
      return { ...state, isInFrame: isInFrame }

    case LayoutActionTypes.SET_VIEWPOST_SIZE: {
      return {
        ...state,
        viewPortWidth: action.payload.width,
        viewPortSize: action.payload.size,
      }
    }

    default:
      return { ...state };
  }
};

export default Layout;
